export default "__VITE_ASSET__CeyPQBd4__"